import * as types from './types';

const initialState = {
	partnerName: '',
};

const partnerReducer = (state = initialState, action) => {
	const {partnerName,type} = action;
	switch (type) {
		case types.SAVE_NAME: {
			return {
				...state,
				partnerName: partnerName
			};
		}
		default:
			return {...state};
	}
};
export default partnerReducer;
